import { COUNTRIES } from '../constants/countries';

export function formatAddressLines(address) {
  if (!address) return [];
  const { address1, address2, city, state, zipcode, country } = address;
  const lines = [];
  if (address1) lines.push(address1);
  if (address2) lines.push(address2);
  const cityState = [city, state].filter(Boolean).join(', ');
  const lastLine = [cityState, zipcode].filter(Boolean).join(' ');
  if (lastLine) lines.push(lastLine);
  if (country && country !== 'US') {
    const match = COUNTRIES.find((c) => c.code === country);
    lines.push(match ? match.name : country);
  }
  return lines;
}
